export const ColorPickerOptions = [
  '#E6E6E6',
  '#F1D2CC',
  '#EFCCB2',
  '#F6E7AF',
  '#DEEBC5',
  '#CBE0F2',
  '#CDDADF',
  '#DFD0EC',
  '#3D3D3D',
  '#952C20',
  '#663E1C',
  '#433829',
  '#436F51',
  '#30509D',
  '#3B5868',
  '#51347D',
];
